<script>
import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  props: {
    chartData: {
      type: Object,
      default: null
    }
  },
  watch: {
    chartData () {
      this.render()
    }
  },
  data () {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
          position: 'bottom',
          onClick: () => {},
          labels: {
            boxWidth: 12
          }
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              precision: 0,
              fontSize: 10
            },
            gridLines: {
              color: '#E5E7EB'
            }
          }],
          xAxes: [{
            ticks: {
              fontSize: 10,
              autoSkip: false
            },
            gridLines: {
              display: false
            }
          }]
        },
        tooltips: {
          mode: 'index',
          intersect: false
        }
      }
    }
  },
  mounted () {
    this.render()
  },
  methods: {
    render () {
      if (!this.chartData) {
        return
      }

      this.renderChart(this.chartData, this.options)
    }
  }
}
</script>
